export default "/dist/fonts/RobotoCondensed-Light.ttf";